var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.show,
        title: _vm.$t("m.live_viola_record"),
        "close-on-click-modal": false,
        "append-to-body": true
      },
      on: {
        "update:visible": function($event) {
          _vm.show = $event
        },
        close: function($event) {
          return _vm.onDialogClose("theForm")
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "theForm",
          attrs: { size: "small", inline: true, model: _vm.model }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { sm: 15, xs: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "operationTimeStart" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetime",
                          placeholder: _vm.$t("m.violation_time"),
                          "value-format": "yyyy-MM-dd HH:mm:ss"
                        },
                        model: {
                          value: _vm.model.operationTimeStart,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "operationTimeStart", $$v)
                          },
                          expression: "model.operationTimeStart"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "coldiv" }, [_vm._v("~")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "operationTimeEnd" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetime",
                          placeholder: _vm.$t("m.violation_time"),
                          "value-format": "yyyy-MM-dd HH:mm:ss"
                        },
                        model: {
                          value: _vm.model.operationTimeEnd,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "operationTimeEnd", $$v)
                          },
                          expression: "model.operationTimeEnd"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.onQueryBtnClick }
            },
            [_vm._v(_vm._s(_vm.$t("m.search")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "text", size: "mini" },
              on: {
                click: function($event) {
                  return _vm.$refs.theForm.resetFields()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("m.reset")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "overline" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading.table,
                  expression: "loading.table"
                }
              ],
              attrs: { data: _vm.tableData, border: "", "max-height": "400" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("m.sereamer_nickname"),
                  prop: "nickName"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("m.violation_reason"),
                  prop: "operationReason",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("m.violation_time"),
                  prop: "operationTime"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("m.live_state_placeholder"),
                  prop: "liveFlagName"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: _vm.$t("m.processing_result"), prop: "hour" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.hour === -1
                          ? _c("span", [_vm._v(_vm._s(_vm.$t("m.permanent")))])
                          : scope.row.hour === 1
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("m.minute", { msg_ss: 15 })))
                            ])
                          : scope.row.hour === 2
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("m.minute", { msg_ss: 30 })))
                            ])
                          : scope.row.hour === 3
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("m.xx_hour", { msg_ss: 1 })))
                            ])
                          : scope.row.hour === 4
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("m.xx_hours", { msg_ss: 12 }))
                              )
                            ])
                          : scope.row.hour === 5
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("m.xx_hours", { msg_ss: 24 }))
                              )
                            ])
                          : scope.row.hour === 6
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("m.xx_hours", { msg_ss: 48 }))
                              )
                            ])
                          : scope.row.hour === 7
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("m.xx_days", { msg_ss: 30 }))
                              )
                            ])
                          : scope.row.hour === 8
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("m.xx_days", { msg_ss: 5 })))
                            ])
                          : scope.row.hour === 9
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("m.xx_days", { msg_ss: 7 })))
                            ])
                          : scope.row.hour === 10
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("m.xx_days", { msg_ss: 15 }))
                              )
                            ])
                          : scope.row.hour === 11
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("m.xx_year", { msg_ss: 1 })))
                            ])
                          : scope.row.hour === 12
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("m.xx_years", { msg_ss: 3 }))
                              )
                            ])
                          : _c("span")
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-134de16f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-134de16f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/approval/dialogs/liveViolationLogDialog.vue
// module id = null
// module chunks = 